import React from "react";
import { InputNumber } from "primereact/inputnumber";
import { ToggleButton } from "primereact/togglebutton";

const ListaToggleButton = ({ field, onChange, ancheInput }) => {


  const handleChange = (indice, val) => {
     debugger
    const aggiornoElementoArray = { ...field.valore[indice], num: val?1:0, totale: val? field.valore[indice].prezzo * 1 :0}
    const result = field.valore.map((item, ind) => (ind === indice ? { ...item[indice], ...aggiornoElementoArray } : item))

    const aggiornoValore = {
      ...field,
      valore: result
    }
    const valoriSelezionatiPerFiltrati = aggiornoValore.valore.filter(ele => ele.num > 0) 
    const prezzoSelezionati = valoriSelezionatiPerFiltrati.reduce((accumulator, currentValue) => accumulator + currentValue.totale, 0);
    
    const aggiornoPrezzoFinale = {
      ...aggiornoValore,
      prezzoFinale: prezzoSelezionati + (field.totaleAncheInput || 0)
    }

    onChange(aggiornoPrezzoFinale)
  }

  const handleChangeAncheInput =  (val) => {

      // aggiorno quantitaAncheInput 
      const aggiornoQuantitaAncheInput = {
        ...field,
        quantitaAncheInput: val,
        totaleAncheInput: val * field.prezzoAncheInput
      }
    debugger
      const aggiornoPrezzoFinale = {
        ...aggiornoQuantitaAncheInput,
        prezzoFinale: aggiornoQuantitaAncheInput.totaleAncheInput + 
                      field.valore.filter(ele => ele.num > 0).reduce((accumulator, currentValue) => accumulator + currentValue.totale, 0)
      }

      onChange(aggiornoPrezzoFinale)
  }

  return (
    <>
      <div className="card flex  col-12  p-2 flex-wrap">
        <label  className="font-medium text-900 justify-content-start">{field.titolo}</label>
      </div>
      <br/>
      <span className="ml-2 mb-4">{field.descrizione}</span>
      {/*<span className="ml-2 mb-4">Clicca le tue scelte: </span>*/}
      <br />
      <div className="flex flex-wrap gap-2 pb-4">

        {field?.valore?.map((elemento, indice) => {
          return (
              <div key={elemento.nome} className="flex align-items-center">
                <ToggleButton  key={elemento.nome} onLabel={elemento.nome} offLabel={elemento.nome} className={"w-12rem"} checked={elemento.num > 0} onChange={(e) => handleChange(indice, e.value)} />
              </div>
          )
        })// fine map
      }
      { field.ancheInput && 
        <div className="field mb-4 col-6 md:col-3">
          <label
            htmlFor="quantitaID"
            className="font-medium text-900"
          >
            {field.descrizioneInput}
          </label>
         
          <InputNumber
            id="quantitaID"
            prefix={field.descQuantita + " "}
            placeholder={field.descrizioneQuantita}
            value={field.quantitaAncheInput}
            onChange={(e) => handleChangeAncheInput( e.value )}
            min="0"
            maxFractionDigits={2}
            locale="it-IT"
          />
        </div>
      
      }{/**fine  anche input */}
      </div>
    </>
  )
}

export default ListaToggleButton; 
